export default __webpack_public_path__ + "static/fk-ddc6bd174c1e6603e32352cbbb63f3fb.svg";